export const getRedirectUrl = (
  surveyId: string,
  answers: Record<string, string>,
) => {
  switch (surveyId) {
    case 'product-market-fit':
      return productMarketFitRedirectRules(answers);
    case 'conditions-pages':
    case 'conditions-articles':
      return conditionsRedirectRules(answers);
    default:
      return {
        thankYouHeader: 'Thank you for submitting your answers!',
        thankYouDescription: 'You likely qualify for a medical card.',
        buttonUrl: '/medical-card',
        buttonLabel: 'Get started',
        imageUrl:
          'https://admin.leafwell.com/app/uploads/2025/05/content-and-image1.svg',
        imageClassName: 'w-2/4 h-auto mt-6 mx-auto',
      };
  }
};

const productMarketFitRedirectRules = (answers: Record<string, string>) => {
  if (
    answers['need-medical-card'] !== 'no' &&
    answers['cannabis-purchases'] === 'yes'
  ) {
    return {
      thankYouHeader: 'Want to save up to 30% at leading dispensaries?',
      thankYouDescription:
        'Leafwell Members access these discounts, plus one-on-one visits with providers and personalized cannabis care plans.',
      buttonUrl: '/membership',
      buttonLabel: 'Learn more',
      imageUrl:
        'https://admin.leafwell.com/app/uploads/2025/05/content-and-image1.svg',
      imageClassName: 'w-2/4 h-auto mt-6 mx-auto',
    };
  }

  if (
    answers['need-medical-card'] !== 'no' &&
    answers['cannabis-purchases'] === 'no'
  ) {
    return {
      thankYouHeader: 'Thank you for submitting your answers!',
      thankYouDescription: 'You likely qualify for a medical card.',
      buttonUrl: '/medical-card',
      buttonLabel: 'Get started',
      imageUrl:
        'https://admin.leafwell.com/app/uploads/2025/05/content-and-image1.svg',
      imageClassName: 'w-2/4 h-auto mt-6 mx-auto',
    };
  }

  if (
    answers['need-medical-card'] === 'no' &&
    answers['cannabis-purchases'] === 'no' &&
    answers['pharmacist-advice'] === 'yes'
  ) {
    return {
      thankYouHeader: 'Thank you for submitting your answers!',
      thankYouDescription: 'You likely qualify for a medical card.',
      buttonUrl: '/medical-card',
      buttonLabel: 'Get started',
      imageUrl:
        'https://admin.leafwell.com/app/uploads/2025/05/content-and-image1.svg',
      imageClassName: 'w-2/4 h-auto mt-6 mx-auto',
    };
  }

  return {
    thankYouHeader: 'Thank you for submitting your answers!',
    thankYouDescription: 'You likely qualify for a medical card.',
    buttonUrl: '/medical-card',
    buttonLabel: 'Get started',
    imageUrl:
      'https://admin.leafwell.com/app/uploads/2025/05/content-and-image1.svg',
    imageClassName: 'w-2/4 h-auto mt-6 mx-auto',
  };
};

const conditionsRedirectRules = (answers: Record<string, string>) => {
  if (answers['looking-relief'] === 'yes' && answers['medical-card'] === 'no') {
    return {
      thankYouHeader: 'You likely qualify for a medical card.',
      thankYouDescription:
        'Find real relief from your symptoms with medical cannabis.',
      buttonUrl: '/medical-card',
      buttonLabel: 'Get a card',
      imageUrl:
        'https://admin.leafwell.com/app/uploads/2025/05/content-and-image1.svg',
      imageClassName: 'w-2/4 h-auto mt-6 mx-auto',
    };
  }

  if (
    answers['looking-relief'] === 'yes' &&
    answers['medical-card'] === 'yes'
  ) {
    return {
      thankYouHeader: 'Want to save up to 30% at leading dispensaries?',
      thankYouDescription:
        'Leafwell Members access these discounts, plus one-on-one visits with providers and personalized cannabis care plans.',
      buttonUrl: '/membership',
      buttonLabel: 'Learn more',
      imageUrl:
        'https://admin.leafwell.com/app/uploads/2025/05/content-and-image1.svg',
      imageClassName: 'w-2/4 h-auto mt-6 mx-auto',
    };
  }

  if (answers['looking-relief'] === 'no' && answers['medical-card'] === 'yes') {
    return {
      thankYouHeader: 'Want to save up to 30% at leading dispensaries?',
      thankYouDescription:
        'Leafwell Members access these discounts, plus one-on-one visits with providers and personalized cannabis care plans.',
      buttonUrl: '/membership',
      buttonLabel: 'Learn more',
      imageUrl:
        'https://admin.leafwell.com/app/uploads/2025/05/content-and-image1.svg',
      imageClassName: 'w-2/4 h-auto mt-6 mx-auto',
    };
  }

  if (
    answers['looking-relief'] === 'no' &&
    answers['need-medical-card'] === 'no'
  ) {
    return {
      thankYouHeader:
        'Are you interested in using cannabis to treat another symptom or condition?',
      thankYouDescription:
        'Connect with a doctor in minutes and get certified for a medical card.',
      buttonUrl: '/medical-card',
      buttonLabel: 'Get started',
      imageUrl:
        'https://admin.leafwell.com/app/uploads/2025/05/content-and-image1.svg',
      imageClassName: 'w-2/4 h-auto mt-6 mx-auto',
    };
  }

  return {
    thankYouHeader:
      'Are you interested in using cannabis to treat another symptom or condition?',
    thankYouDescription:
      'Connect with a doctor in minutes and get certified for a medical card.',
    buttonUrl: '/medical-card',
    buttonLabel: 'Get started',
    imageUrl:
      'https://admin.leafwell.com/app/uploads/2025/05/content-and-image1.svg',
    imageClassName: 'w-2/4 h-auto mt-6 mx-auto',
  };
};
